export default "__VITE_ASSET__CE674Bu9__"